export type RecurrenceFrequency = "daily" | "weekly" | "monthly";

/**
 * Expands a recurrence into the concrete start dates the backoffice posts to
 * `POST /events/recurrent`. The worker persists what it is given: it does not
 * recompute this list, so whatever comes out of here is the series users end up
 * seeing.
 *
 * Dates are compared by calendar day, so the time of day of `end` never cuts
 * the last occurrence short, and each occurrence keeps the time of `start`.
 */
export const generateRecurringDates = (
  start: Date,
  end: Date,
  type: RecurrenceFrequency
): Date[] => {
  const dates: Date[] = [];
  const current = new Date(start);

  const endTimestamp = new Date(
    end.getFullYear(),
    end.getMonth(),
    end.getDate()
  ).getTime();

  while (
    new Date(
      current.getFullYear(),
      current.getMonth(),
      current.getDate()
    ).getTime() <= endTimestamp
  ) {
    dates.push(new Date(current));

    if (type === "daily") current.setDate(current.getDate() + 1);
    else if (type === "weekly") current.setDate(current.getDate() + 7);
    else if (type === "monthly") current.setMonth(current.getMonth() + 1);
  }

  return dates;
};
